import React from 'react';
import { AgendaItem } from '../types';
import AgendaItemCard from './AgendaItemCard';

interface AgendaDayProps {
  date: string;
  items: AgendaItem[];
  onItemClick: (item: AgendaItem) => void;
  registeredAgendaItemIds?: Set<number>;
  myArbeitsgruppeId?: number | null;
}

const AgendaDay: React.FC<AgendaDayProps> = ({ date, items, onItemClick, registeredAgendaItemIds, myArbeitsgruppeId }) => {
  return (
    <div className="mb-12">
      <h2 className="text-xl md:text-2xl font-bold text-gray-700 mb-6 border-b-2 border-primary pb-2">
        {date}
      </h2>
      <div className="relative">
        {/* Vertical timeline bar */}
        <div className="absolute left-5 top-2 bottom-2 w-0.5 bg-gray-200"></div>
        {items.map((item, index) => (
          <AgendaItemCard
            key={item.id}
            item={item}
            isLast={index === items.length - 1}
            onClick={onItemClick}
            isActivityGroupRegistered={registeredAgendaItemIds?.has(item.id) === true}
            isArbeitsgruppeRegistered={item.type === 'arbeitsgruppen' && !!myArbeitsgruppeId}
          />
        ))}
      </div>
    </div>
  );
};

export default AgendaDay;
